import { core } from '@mentimeter/http-clients';
import useSWR from 'swr';
import { formatVoteCode } from './formatVoteCode';

async function fetchVoteCode(seriesId: string) {
  const { data } = await core().series.voteCode.get(seriesId);

  return data;
}

/**
 * This is to be used in situations where we want to get the
 * vote code without generating a new one, such as public view.
 * Can be used in voting as the endpoint does not require
 * authentication.
 * @param seriesId - series id
 * @returns formatted vote code as string
 */
export function useVoteCodeWithoutGenerating(seriesId: string): string {
  const { data } = useSWR(
    [`/series/${seriesId}/vote-code`, 'get'],
    () => fetchVoteCode(seriesId),
    {
      revalidateIfStale: false,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      shouldRetryOnError: false,
      refreshInterval: (currentData) => (currentData?.expires_in ?? 0) * 1000,
    },
  );

  const formatted = data && data.id ? formatVoteCode(data.id) : '';

  return formatted;
}
